import styled from 'styled-components';

export const StyledPipaSection = styled.div`
  font-family: var(--font-family), Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  margin-top: 8px;
  max-width: 100%;

  @media only screen and (min-width: 1280px) {
    font-size: 24px;
    margin-bottom: 2px;
  }
` as any;
